import * as TYPES from '../types';
const initialState = [];
export const customTable = (state ={}, action) => { // to review
    const newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
      case TYPES.GET_CUSTOM_TABLE:
        if(!newState.customTable){
            newState.customTable = {};
          }
        newState.customTable = action.customTable;
        return newState;
      case TYPES.GET_CUSTOM_TABLE_LIVE:
        if(!newState.customTableLive){
            newState.customTableLive = {};
          }
        newState.customTableLive = action.customTableLive;
        return newState;
      default:
        return state;
    }
  };